import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'formik';
import { AGES } from '../../utils/ageGroups';
import TextInput from '../Global/Forms/TextInput';
import EmailInput from '../Global/Forms/EmailInput';
import CheckboxInput from '../Global/Forms/CheckboxInput';
import RadioInput from '../Global/Forms/RadioInput';
import SignupPrimaryRole from './SignupPrimaryRole';

const UserInformation = ({ title, values, errors, touched, onChange, onPrimaryRoleChange }) => (
  <div className="user-information">
    {title}
    <fieldset className="m-b-5">
      <div className="row">
        <div className="col-lg-6">
          <TextInput
            name="firstName"
            label="First name"
            maxLength={50}
            value={values.firstName}
            onChange={onChange}
            error={errors.firstName}
            touched={touched.firstName}
            required
          />
        </div>

        <div className="col-lg-6">
          <TextInput
            name="lastName"
            label="Last name"
            maxLength={50}
            value={values.lastName}
            onChange={onChange}
            error={errors.lastName}
            touched={touched.lastName}
            required
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <EmailInput
            name="emailAddress"
            label="Email address"
            maxLength={200}
            value={values.emailAddress}
            onChange={onChange}
            error={errors.emailAddress}
            touched={touched.emailAddress}
            required
          />
        </div>

        <div className="col-lg-6">
          <EmailInput
            name="confirmEmailAddress"
            label="Confirm email address"
            maxLength={200}
            value={values.confirmEmailAddress}
            onChange={onChange}
            error={errors.confirmEmailAddress}
            touched={touched.confirmEmailAddress}
            required
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <SignupPrimaryRole
            isCoach={values.isCoach}
            isPlayer={values.isPlayer}
            onChange={onPrimaryRoleChange}
          />
        </div>

        <div className="col-lg-6">
          {values.isCoach === true &&
            <div className="form-group form-inline">
              <span className="faux-label">Age groups you coach</span>
              <p className="like-small color-grey">Choosing will help us tailor content and search</p>

              <FieldArray
                name="coachAgeGroup"
                render={arrayHelpers => (
                  <div className="form-inline__field-container">
                    {AGES.map(coachAge => (
                      <CheckboxInput
                        key={coachAge.value}
                        name="coachAgeGroup"
                        label={coachAge.displayName}
                        value={coachAge.value}
                        checked={values.coachAgeGroup.includes(coachAge.value)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            arrayHelpers.push(coachAge.value);
                          } else {
                            const value = values.coachAgeGroup.indexOf(coachAge.value);
                            arrayHelpers.remove(value);
                          }
                        }}
                      />
                    ))}
                  </div>
                )}
              />
            </div>
          }

          {/* {values.isPlayer === true &&
            <div className="form-group form-inline">
              <span className="faux-label">Your age group</span>
              <p className="like-small color-grey">Choosing will help us tailor content and search</p>

              <div className="form-inline__field-container">
                <RadioInput
                  name="playerAgeGroup"
                  label="5–8"
                  onChange={onChange}
                  value="5-8"
                  checked={values.playerAgeGroup === '5-8'}
                />

                <RadioInput
                  name="playerAgeGroup"
                  label="9–12"
                  onChange={onChange}
                  value="9-12"
                  checked={values.playerAgeGroup === '9-12'}
                />

                <RadioInput
                  name="playerAgeGroup"
                  label="13+"
                  onChange={onChange}
                  value="13+"
                  checked={values.playerAgeGroup === '13+'}
                />
              </div>
            </div>
          } */}
        </div>
      </div>
    </fieldset>
  </div>
);

UserInformation.propTypes = {
  title: PropTypes.object,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onPrimaryRoleChange: PropTypes.func.isRequired,
};

export default UserInformation;



// WEBPACK FOOTER //
// ./library/app/components/Signup/UserInformation.js